var O = { STORYBOOK_FACEBOOK_LIKE_URL: "https://www.facebook.com/plugins/like.php?href", STORYBOOK_AUTH_CALLBACK_URL: "https://www.scmp.com/centralize/signin?nonce", STORYBOOK_SCMP_ACCOUNT_HOST: "https://account.scmp.com", STORYBOOK_SITE_URL: "https://www.scmp.com", STORYBOOK_ROSETTA_HOST: "https://subscribe.scmp.com", STORYBOOK_CONTENTSERVICE_HOST: "https://apigw.scmp.com/content-delivery/v2", STORYBOOK_REGISTER_CALLBACK_URL: "https://www.scmp.com/centralize/register?email", STORYBOOK_RECAPTCHA_SITE_KEY: "6Lfb87QZAAAAAHADh5nv4kdK5f1eKu87MIByoimj", STORYBOOK_CONTENTSERVICE_APIKEY: "MyYvyg8M9RTaevVlcIRhN5yRIqqVssNY", STORYBOOK_CORPORATE_SUBSCRIBER_HOST: "https://staging-apigw.product-web.dev-2.scmp.tech/corp-subscriber-tier/v1/tier" }, e, s, T, _, R, o, t, S, c, n;
const i = {
  accounts: {
    authCallbackUrl: (e = O.STORYBOOK_AUTH_CALLBACK_URL) !== null && e !== void 0 ? e : "",
    host: (s = O.STORYBOOK_SCMP_ACCOUNT_HOST) !== null && s !== void 0 ? s : "",
    registerCallbackUrl: (T = O.STORYBOOK_REGISTER_CALLBACK_URL) !== null && T !== void 0 ? T : ""
  },
  corporateSubscriber: {
    host: (_ = O.STORYBOOK_CORPORATE_SUBSCRIBER_HOST) !== null && _ !== void 0 ? _ : ""
  },
  environment: "dev",
  facebook: {
    appId: "282931841805811",
    likeUrl: (R = O.STORYBOOK_FACEBOOK_LIKE_URL) !== null && R !== void 0 ? R : ""
  },
  graphql: {
    apiKey: (o = O.STORYBOOK_CONTENTSERVICE_APIKEY) !== null && o !== void 0 ? o : "",
    host: (t = O.STORYBOOK_CONTENTSERVICE_HOST) !== null && t !== void 0 ? t : ""
  },
  newsletter: {
    globalImpact: "506194",
    lunar: "501957",
    postMag: "322743",
    thisWeekInAsia: "323063"
  },
  notification: {
    // No need to take from environment since it's being mocked
    host: ""
  },
  readingHistory: {
    // No need to take from environment since it's being mocked
    apiKey: "",
    host: "/reading-history"
  },
  recaptcha: {
    siteKey: (S = O.STORYBOOK_RECAPTCHA_SITE_KEY) !== null && S !== void 0 ? S : ""
  },
  siteUrl: (c = O.STORYBOOK_SITE_URL) !== null && c !== void 0 ? c : "",
  subscribe: {
    host: (n = O.STORYBOOK_ROSETTA_HOST) !== null && n !== void 0 ? n : ""
  },
  twitter: {
    accountName: "SCMPnews"
  }
};
export {
  i as defaultConfig
};
//# sourceMappingURL=index9.mjs.map
